<template>
<div id="modal-template">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          
          <div>
            <div class="modal-default-button" @click="$emit('close')">x</div>
          </div>

          <div class="modal-header">
            <slot name="header">
             <span class="aria-center">{{this.serialNumber}}</span>
            </slot>
          </div>



          <div class="modal-body aria-center">
            <slot name="body">
              <sapn class="aria-center">사용중 OTP 확인</sapn>
              <base-input type="text" class="text-center" v-model="otpNumber" readOnly="true">
              </base-input>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
               <button class="btn btn-wd btn-info" @click="$emit('close')">
               무제한 해지
              </button>
               <button class="btn btn-wd btn-default" @click="$emit('close')">
               닫기
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
  import BaseInput from 'src/components/Inputs/BaseInput.vue'

  export default {
    components: {
     BaseInput
    },
    props: {
      serialNumber: {
        type: String
      }
    },
    data() {
      return {
        otpNumber: '5647-3845-2928'
      }
    }
  }

</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 440px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.aria-center {
    margin: 0px auto;
    text-align: center;
}
</style>